import { normalizeApiErrors, type ApiFieldErrors, type NormalizedApiErrors } from './normalizeErrors';

export type ApiEnvelope<T> = {
  message: string | null;
  data: T;
};

/** Backend error envelope from ApiResponseTrait and exception handlers. */
export type ApiErrorEnvelope = {
  message: string | null;
  errors?: unknown;
};

export class ApiError extends Error {
  readonly httpStatus: number;
  readonly apiMessage: string | null;
  readonly errors: NormalizedApiErrors;

  constructor(opts: {
    message: string;
    httpStatus: number;
    errors?: unknown;
  }) {
    super(opts.message);
    this.name = 'ApiError';
    this.httpStatus = opts.httpStatus;
    this.apiMessage = opts.message || null;
    this.errors = normalizeApiErrors(opts.errors, opts.httpStatus, opts.message);
  }

  /** Field-keyed errors for form binding. */
  get fieldErrors(): ApiFieldErrors {
    return this.errors.fields;
  }
}

export type PaginationMeta = {
  current_page: number;
  per_page: number;
  total: number;
  last_page: number;
};
